import { z } from 'zod';

export const formSchema = z.object({
  deadlineDate: z.date({
    required_error: 'Informe o prazo de entrega',
  }),
  comment: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;
